<template>
    <header class="header-wapper header-sticky" >
        <div class="pd-12 top-border-bottom">
            <a class="exch-breadcrumb-heading-sec" @click="$router.go(-1)">
                <img  src="@/assets/images/back.webp" alt="back" >
                <h5>{{$t('faq-title','Frequently asked questions (FAQ)')}}</h5>
            </a>
        </div>
    </header>
    <div class="col-12 col-sm-12 col-md-12">
        <section class="faq-container" v-if="tutorials.length">
            <div class="faq-ques-list">
                <div class="faq-question-box" v-for="(tut, idx) in tutorials" :key="tut.videoKey">
                    <div class="faq-quis-left-title">
                        <h5>{{ idx + 1 }}. {{ tut.title }}</h5>
                        <p>{{$t('watch-video-text','Watch the video tutorial')}}!</p>
                    </div>
                    <a href="javascript:void(0)" data-bs-toggle="modal" data-bs-target="#faqVideoModal" @click="playVideo(tut.videoKey, tut.imageKey, tut.title)">{{$t('click-here','Click here')}} </a>
                </div>
                
            </div>
        </section>
    </div>
    <div class="modal fade worli-Bets-Modal" id="faqVideoModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">

                <div class="modal-header">
                    <h5 class="modal-title">{{videoTitle}}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                        <i class="fa-solid fa-xmark"></i>
                    </button>
                </div>
                <hr />
                <div class="modal-body">
                    <video controls :poster="videoThumbnail" :src="videoUrl" class="video-display"></video>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Faq',
    data() {
        return {
            videoUrl: null,
            videoTitle: null,
            videoThumbnail: null
        }
    },
    computed: {
        tutorials() {
            const journey = this.$siteSettings?.data?.user_journey ?? {};

            const allTutorials = [
                { title: "How to Login",            videoKey: "login_video",        imageKey: "login_img"      },
                { title: "How to Register",         videoKey: "register_video",     imageKey: "register_img"   },
                { title: "Introduction",            videoKey: "introduction_video", imageKey: null             },
                { title: "How to Withdraw",         videoKey: "withdrawal_video",   imageKey: null             },
                { title: "How to Play",             videoKey: "play_video",         imageKey: "play_img"       },
                { title: "How to Play Bonus",       videoKey: "use_bonus_video",    imageKey: null             },
                { title: "How to Deposit English",  videoKey: "deposit_video_e",    imageKey: null             },
                { title: "How to Deposit Hindi",    videoKey: "deposit_video_h",    imageKey: null             },
            ];

            return allTutorials.filter(t => Boolean(journey[t.videoKey]));
        }
    },
    methods: {
        playVideo(videoKey, imageKey, title) {
            const base = this.$siteSettings?.data?.user_journey;
            this.videoUrl       = this.$siteSettings?.data?.aws_url + this.$siteSettings?.data?.storage_path.user_journey_path + base[videoKey];
            this.videoThumbnail = imageKey ? this.$siteSettings?.data?.aws_url + this.$siteSettings?.data?.storage_path.user_journey_path + base[imageKey] : null;
            this.videoTitle     = title;
        }
    }
}
</script>
<style scoped>
.video-display{
  height: 160px;
  width: 100%;
}
</style>